"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { useAuth } from "@/providers/auth-provider";
import { getPersonalRecommendations } from "@/lib/actions/recommendation-actions";
type Recommendations = Awaited<ReturnType<typeof getPersonalRecommendations>>;
// Browser-memory only, one account, one minute. Never persist reading-derived
// ordering in localStorage, and never share it through a public server cache.
let cached: {
  userId: string;
  until: number;
  promise: Promise<Recommendations>;
} | null = null;
export function useRecommendations(enabled) {
  const $ = _c(5);
  const {
    user,
    loading
  } = useAuth();
  const userId = user?.id;
  const [result, setResult] = useState(null);
  let t0;
  let t1;
  if ($[0] !== enabled || $[1] !== loading || $[2] !== userId) {
    t0 = () => {
      if (!enabled || loading || !userId) {
        if (!loading && !userId) {
          cached = null;
        }
        return;
      }
      let active = true;
      if (!cached || cached.userId !== userId || cached.until <= Date.now()) {
        cached = {
          userId,
          until: Date.now() + 60000,
          promise: getPersonalRecommendations().catch(_temp)
        };
      }
      cached.promise.then(value => {
        if (active) {
          setResult(value);
        }
      });
      return () => {
        active = false;
      };
    };
    t1 = [enabled, loading, userId];
    $[0] = enabled;
    $[1] = loading;
    $[2] = userId;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
  return enabled && !loading && userId && result?.userId === userId ? result : null;
}
function _temp() {
  return null;
}